import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { DonorResponse, FormDonorPostItem, FormDonorPutItem } from 'src/modules/gift/models/donor';

const controller = 'Donor';

export const getDonors = (pageIndex, pageSize, sortCol, sortDir, searchFilter) => {
  const extraQuery = searchFilter ? `&filter=${searchFilter}` : '';
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<DonorResponse>>(endpoint);
};

export const getDonorById = (id: number | string) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<DonorResponse>(endpoint);
};

export const createForDonor = (donor: FormDonorPostItem) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<number>(endpoint, donor);
};
export const updateForDonor = (donor: FormDonorPutItem) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<FormDonorPutItem>(endpoint, donor);
};

export const deleteForDonor = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete<DonorResponse>(endpoint);
};
